import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CasepackService {

  constructor(private http: HttpClient) { }

  postCasePack(formData):Observable<any>{

    return this.http.post(environment.apiBaseURI + '/CasePack', formData);
  }

  putCasePack(formData){
    return this.http.put(environment.apiBaseURI + '/CasePack/' + formData.id, formData);
  }

  getCasePackList(param: any){
    return this.http.post(environment.apiBaseURI + '/CasePack/GetCasePackDetails', param);
  }

  getCasePacks(){
    return this.http.get(environment.apiBaseURI + '/CasePack/GetCasePackDetailsList');
  }

  deleteCasePack(id){
    return this.http.delete(environment.apiBaseURI + '/CasePack/' + id);
  }
}
